import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private fetrapiSession: any = {};

  constructor() {}

  public setFetrapiSession(session: string): void {
    console.log('SET FETRAPI SESSION', session);
    this.fetrapiSession = JSON.parse(session);
  }

  public hasFetrapiSession(): boolean {
    return Object.keys(this.fetrapiSession).length > 0;
  }

  public getDisplayname(): string {
    const displayname = this.fetrapiSession['displayName'] ?? '';
    console.log('MAIL', displayname);
    return displayname;
  }

  public getPreferredLanguage(): string {
    const preferredLanguage =
      this.fetrapiSession['preferredLanguage'] == 'NL' ? 'Dutch' : 'French';
    console.log('PREFERRED LANGUAGE', preferredLanguage);
    return preferredLanguage;
  }

  public getMail(): string {
    const mail = this.fetrapiSession['mail'] ?? '';
    const othermails: string[] = this.fetrapiSession['otherMails'] ?? [];
    const value = othermails.length > 0 ? othermails : mail;
    console.log('MAIL', value);
    return value;
  }

  public getMaingroup(): any {
    const maingroup = this.fetrapiSession.mainGroup ?? ''; //['maingroup'];
    console.log('MAINGROUP', maingroup);
    return maingroup;
  }

  public getMaingroupName(): string {
    const maingroupName = this.fetrapiSession.mainGroup.name ?? ''; //['maingroup'];
    console.log('MAINGROUP_NAME', maingroupName);
    return maingroupName;
  }

  public getMaingroupGId(): string {
    const maingroupGId = this.fetrapiSession.mainGroup.gId ?? ''; //['maingroup'];
    console.log('MAINGROUP_gID', maingroupGId);
    return maingroupGId;
  }

  public getGroup(): any {
    const group = this.fetrapiSession.group ?? ''; //['group'];
    console.log('GROUP', group);
    return group;
  }

  public getGroupName(): string {
    const groupName = this.fetrapiSession.group.name ?? ''; //['group'];
    console.log('GROUP_NAME', groupName);
    return groupName;
  }

  public getGroupGId(): string {
    const groupGId = this.fetrapiSession.group.gId ?? ''; //['group'];
    console.log('GROUP_gID', groupGId);
    return groupGId;
  }
}
